const getExtension = (filename:string) => {
  const dotIndex = filename.lastIndexOf('.');
  if (dotIndex === -1 || dotIndex === filename.length - 1) {
    return ''; // 文件名中没有后缀名
  }
  return filename.substring(dotIndex + 1).toLowerCase();
};

//将选择的文件生成预览
function getObjectURL(file: any) {
  var url = null;
  if (window.URL != undefined) { // mozilla(firefox)
    url = window.URL.createObjectURL(file);
  } else if (window.webkitURL != undefined) { // webkit or chrome
    url = window.webkitURL.createObjectURL(file);
  }
  return url;
}

export {getExtension,getObjectURL};
